export const logoLineAnim = {
    start: {
        pathLength: 0,
        rotate: 180,
    },
    end: {
        pathLength: 1,
        rotate: 180,
        transition: {
            type: 'linear',
            duration: 1,
        }
    }
}
export const logoCircleAnim = {
    start: {
        pathLength: 0,
        // 
    },
    end: {
        pathLength: 1,
        // scaleX: -1,
        transition: {
            type: 'linear',
            duration: 1,
        }
    }
}
export const helloPAnim = {
    start: {
        y: 100,
    },
    end: {
        y: 0,
        transition: {
            type: 'linear',
            duration: 1,
        }
    }
}